<template lang="pug">
  #CenterSearch
    form(@submit.prevent="toSearch" @keyup.enter="toSearch" :class="{'type-modal': type == 'modal' }")
      img(:src="img.icoClient" width="22")
      label #[translate Buscar centros]
      .input-group
        input( id="product-search-query" class="form-control" type="search" @keyup="changeSearch" @search="toSearch()" v-model="query" :placeholder="placeholder.search" value="")
        span.input-group-btn
          button.btn.btn-action(type="submit")
            img(:src="img.lupa" width="16" title="Search")
</template>
<script>
export default {
  name: 'CenterSearch',
  props: ['count', 'type', 'q'],
  data () {
    return {
      query: '',
      timerSearch: null,
      img: {
        icoClient: require('@/assets/img/icos/cliente_2.svg'),
        lupa: require('@/assets/img/icos/buscar.svg')
      },
      placeholder: {
        'search': this.$gettext('id, nombre, código postal, ciudad y provincia.')
      }
    }
  },
  created () {
  },
  methods: {
    changeSearch () {
      let ref = this
      clearTimeout(this.timerSearch)
      this.timerSearch = setTimeout(() => {
        // console.log('---busca')
        ref.toSearch()
      }, 1000)
    },
    toSearch () {
      // console.log(`buscar por: ${query}`)
      if (this.query === null || this.query === '' || this.query.length > 2) {
        // console.log(`to search: ${query},  ${query.length}`)
        // this.q = ''
        this.$emit('toSearch', [this.query])
      }
    }
  },
  watch: {
    q () {
      // actualizamos el valor de los pedidos pendientes.
      this.query = this.q
    }
  }
}
</script>
<style lang="scss" scoped>

  label{
    font-weight: $regular;
    font-size:14px;
    color: #1C2C40;
    padding:0 30px 0 10px;

  }

  .input-group{
    max-width: 780px;
    display: inline-table;
    vertical-align: middle;
  }

  .btn-action{
    border-color: $white;
    width: 40px;
    line-height: 46px;
    padding: 0;
    img{
      // max-width: none;
    }
  }

  #product-search-query{
    line-height: 40px;
    height: 46px;
  }

  .type-modal{
    .input-group{
      max-width: 626px;
    }
  }


</style>
